var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    rx: 12,
    fill: "#201E26"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 9.31372,
    width: 12.6667,
    height: 18.6275,
    rx: 5,
    fill: "#A1A3B2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.833 17.8774C15.4188 17.8774 15.083 18.2132 15.083 18.6274C15.083 19.0417 15.4188 19.3774 15.833 19.3774L15.833 17.8774ZM29.03 19.1578C29.3229 18.8649 29.3229 18.39 29.03 18.0971L24.257 13.3241C23.9641 13.0312 23.4893 13.0312 23.1964 13.3241C22.9035 13.617 22.9035 14.0919 23.1964 14.3848L27.439 18.6274L23.1964 22.8701C22.9035 23.163 22.9035 23.6378 23.1964 23.9307C23.4893 24.2236 23.9641 24.2236 24.257 23.9307L29.03 19.1578ZM15.833 19.3774L28.4997 19.3774L28.4997 17.8774L15.833 17.8774L15.833 19.3774Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.6e11227d799a3bd6a20b7e57c3e3cfe0.svg";
export { ForwardRef as ReactComponent };